import React from "react";

const formatCompact = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return value.toLocaleString("en-IN");
};

const StatCard = ({ label, value, displayValue, loading }) => {
  return (
    <div className="dash-stat-card">
      <div className="dash-stat-label">{label}</div>
      {loading ? (
        <div className="dash-stat-skeleton" />
      ) : (
        <div className="dash-stat-value">{displayValue !== undefined ? displayValue : formatCompact(value)}</div>
      )}
    </div>
  );
};

export default StatCard;
